import { msg } from '~/utils/validation';
import { z } from 'zod';

export const schema = z.object({
  club: z.tuple([z.string(), z.number()], { message: msg.required }),
  year: z.coerce.number({ message: msg.required }),
});

export type Schema = z.infer<typeof schema>;
